<nav class="component-top-view">
  <div class="component-top-view__left">
    <button class="component-top-view__hamburger" (click)="toggleNavigation()" aria-label="Toggle menu">
      <span></span>
      <span></span>
      <span></span>
    </button>
    <a routerLink="/reports" class="component-top-view__logo" (click)="resetSearchQuery()">
      <span class="component-top-view__logo-badge">WYD</span>
      <span class="component-top-view__logo-text">WowYourData</span>
    </a>
  </div>

  <div class="component-top-view__links">
    <a routerLink="/data-dictionary" class="component-top-view__link component-top-view__link--dict" routerLinkActive="active">
      <i class="ti ti-book-2"></i> Data Dictionary
    </a>
    <app-login-user [smallView]="true" [loginURL]="loginURL"></app-login-user>
    <a routerLink="/faq" class="component-top-view__link" routerLinkActive="active">FAQ</a>
    <a routerLink="/contact" class="component-top-view__link" routerLinkActive="active">Contact</a>
  </div>
</nav>
